import $ from 'jquery'
import { Util } from 'bootstrap'
import Fonts from './fonts'

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'fontpreview'
const DATA_KEY = `opp.${NAME}`
const EVENT_KEY = '.' + DATA_KEY
const DATA_API_KEY = '.data-api'
const JQUERY_NO_CONFLICT = $.fn[NAME]

const Selector = {
  DATA_FONT_PREVIEW: '[data-font-preview]',
  DATA_TOGGLE: '[data-toggle="font-preview"]',
  FONT_PREVIEW_DATA: '.font-preview-data',
  FONT_PREVIEW_NAME: ':not(img).font-preview-name',
  FONT_PREVIEW_TEXT: ':not(img).font-preview-text',
  FONT_PREVIEW_NAME_IMG: 'img.font-preview-name',
  FONT_PREVIEW_TEXT_IMG: 'img.font-preview-text'
}

Selector.FONT_PREVIEWS = [Selector.FONT_PREVIEW_NAME, Selector.FONT_PREVIEW_TEXT].join(',')

const Event = {
  CHANGE_DATA_API: `change${EVENT_KEY}${DATA_API_KEY}`
}

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class FontPreview {
  constructor(element) {
    this._element = element
    this._font = this._getFont()
    this._loadFont(this._font)
  }

  // Public

  show(font) {
    // Update and load font
    if (font) {
      this._font = font
      this._loadFont(font)
    }

    if (this._font) {
      // Update element if font has changed
      if (this._font.id !== $(this._element).data('font-id')) {
        $(this._element).data('font-id', this._font.id)
        $(this._element).find(Selector.FONT_PREVIEW_NAME).text(this._font.name)
        $(this._element).find(Selector.FONT_PREVIEWS).css(Fonts.styleProps(this._font))
        $(this._element).find(Selector.FONT_PREVIEW_NAME_IMG).attr({
          title: this._font.name,
          src: this._font.preview_url
        })
        $(this._element).find(Selector.FONT_PREVIEW_TEXT_IMG).attr({
          title: this._font.name + ' sample',
          src: this._font.sample_url
        })
      }

      // Show optional collapse
      $(this._element).closest('.collapse').collapse('show')
    }
  }

  // Private

  _getFont() {
    const el = this._element.querySelector(Selector.FONT_PREVIEW_DATA)
    if (el && el.text) {
      return JSON.parse(el.text)
    }
  }

  _loadFont(font) {
    if (font) {
      // N.B. Preview text element may not exist.
      const $text = $(this._element).find(Selector.FONT_PREVIEW_TEXT)
      if ($text[0]) {
        // N.B. Use `font.name` since `FONT_PREVIEW_NAME` element may be stale.
        const text = String(font.name) + $text.text()
        $(this._element.ownerDocument).fontloader('load', font, text)
      }
    }
  }

  // Static

  static _jQueryInterface(config, ...args) {
    return this.each(function () {
      let data = $(this).data(DATA_KEY)
      if (!data) {
        data = new FontPreview(this)
        $(this).data(DATA_KEY, data)
      }

      if (typeof config === 'string') {
        if (typeof data[config] === 'undefined') {
          throw new TypeError(`No method named "${config}"`)
        }

        data[config](...args)
      }
    })
  }
}

/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */

FontPreview._jQueryInterface.call($(Selector.DATA_FONT_PREVIEW), 'show')

$(document).on(Event.CHANGE_DATA_API, Selector.DATA_TOGGLE, function (event, font) {
  const selector = Util.getSelectorFromElement(this)
  FontPreview._jQueryInterface.call($(selector), 'show', font)
})

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = FontPreview._jQueryInterface
$.fn[NAME].Constructor = FontPreview
$.fn[NAME].noConflict = () => {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return FontPreview._jQueryInterface
}

export default FontPreview
